<template>
  <div class="praise">
    <div class="by">
      <div class="clearfix">
        <el-button @click="add('good')" class="fr" type="primary" size="small"
          >新 增</el-button
        >
        <el-button
          v-if="showSort"
          @click="saveSort"
          style="margin-right: 20px"
          class="fr"
          type="primary"
          size="small"
          >保存排序</el-button
        >
      </div>
      <h2>表扬</h2>
      <div class="clearfix">
        <draggable
          v-model="goodTableDate"
          @update="datadragEnd"
          :options="{ animation: 200 }"
        >
          <div
            class="box fl"
            :key="i.id"
            @mouseover="mouseover(i.id)"
            @mouseleave="mouseleave"
            v-for="i in goodTableDate"
          >
            <transition name="el-fade-in-linear" v-if="isAdmin">
              <div class="del-transition-box" v-show="curIdHover == i.id">
                <el-button
                  @click="showDelPop(i.id)"
                  class="del-transition-but"
                  type="danger"
                  plain
                  icon="el-icon-delete"
                  size="small"
                  circle
                ></el-button>
              </div>
            </transition>
            <div class="score-rel">
              <div class="score">{{ i.evalScore }}</div>
            </div>
            <el-image class="iconPng" :src="i.iconUrl" fit="cover"> </el-image>
            <h1>{{ i.evalTitle }}</h1>
          </div>
        </draggable>
      </div>
    </div>
    <div class="by">
      <h2>提醒</h2>
      <div class="clearfix">
        <draggable
          v-model="badTableDate"
          @update="datadragEnd"
          :options="{ animation: 200 }"
        >
          <div
            class="box fl"
            :key="i.id"
            @mouseover="mouseover(i.id)"
            @mouseleave="mouseleave"
            v-for="i in badTableDate"
          >
            <transition name="el-fade-in-linear"  v-if="isAdmin">
              <div class="del-transition-box" v-show="curIdHover == i.id">
                <el-button
                  @click="showDelPop(i.id)"
                  class="del-transition-but"
                  type="danger"
                  plain
                  icon="el-icon-delete"
                  size="small"
                  circle
                ></el-button>
              </div>
            </transition>
            <div class="score-rel">
              <div class="score score-woring">{{ i.evalScore }}</div>
            </div>
            <el-image class="iconPng" :src="i.iconUrl" fit="cover"> </el-image>
            <h1>{{ i.evalTitle}}</h1>
          </div>
        </draggable>
      </div>
    </div>

    <!-- 新增的对话框 -->
    <el-dialog
      class="add-pop"
      :visible.sync="addVisible"
      :close-on-click-modal="false"
      :showClose="false"
      top="6%"
    >
      <template v-slot:title>
        <div class="add-title">编辑表扬与提醒</div>
      </template>
      <div class="clearfix">
        <div class="right-box">
          <!-- 指标 -->
          <template>
            <div class="check-radio">
              <el-radio-group v-model="serachType" size="medium">
                <el-radio-button label="sys" class="student"
                  >系统指标</el-radio-button
                >
                <el-radio-button label="myself" class="team"
                  >自定义指标</el-radio-button
                >
              </el-radio-group>
            </div>

            <div class="context">
              <!--系统标签 -->
              <div class="sys-box clearfix" v-if="serachType == 'sys'">
                <el-checkbox-group v-model="checkSysIconList">
                  <div v-for="i in sysIconList" :key="i.id" class="icon-box fl">
                    <div class="check-select">
                      <el-checkbox
                        :label="i"
                        :key="i.id"
                        class="check-box"
                        size="medium"
                        border
                      ></el-checkbox>
                    </div>
                    <!-- 图片 -->
                    <el-image
                      :key="i.id"
                      class="iconPng"
                      :src="i.iconUrl"
                      fit="cover"
                    >
                    </el-image>
                    <h1>{{ i.evalTitle }}</h1>
                  </div>
                </el-checkbox-group>
              </div>
              <!-- 自定义 -->
              <div class="myself-box" v-if="serachType == 'myself'">
                <div v-if="isFormBox" class="form-box">
                  <el-form
                    ref="myselfForm"
                    :rules="rules"
                    :model="form"
                    label-width="79px"
                  >
                    <el-form-item label="" prop="iconUrl">
                      <el-image
                        class="iconPng"
                        v-if="form.iconUrl"
                        :src="form.iconUrl"
                        @click.native="goIconPlan"
                        fit="cover"
                      >
                      </el-image>
                      <el-button
                        v-if="!form.iconUrl"
                        class="select-icon-but el-icon-plus"
                        @click="goIconPlan"
                        circle
                      ></el-button>
                    </el-form-item>

                    <el-form-item label="名称" prop="evalTitle">
                      <el-input
                        size="small"
                        placeholder="不能超过10个字"
                        v-model="form.evalTitle"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="学科" prop="disciplineName">
                      <el-input
                        size="small"
                        placeholder="不能超过10个字"
                        disabled
                        v-model="form.disciplineName"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="分值" prop="evalScore">
                      <el-input
                        size="small"
                        type="number"
                        disabled
                        v-model="form.evalScore"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="类型" prop="evalClassify">
                      <el-radio-group v-model="form.evalClassify" size="small">
                        <el-radio-button label="good" border
                          >表扬</el-radio-button
                        >
                        <el-radio-button label="bad" border
                          >提醒</el-radio-button
                        >
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item label="指标目录" prop="catalogCode">
                      <el-select
                        v-model="form.catalogCode"
                        placeholder="请选择"
                        size="small"
                      >
                        <el-option
                          v-for="item in activeLabelInfo.catalogList"
                          :key="item.id"
                          :label="item.catalogName"
                          :value="item.catalogCode"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="评价标签" prop="tagCodes">
                      <el-select
                        v-model="form.tagCodes"
                        placeholder="请选择"
                        size="small"
                        multiple
                      >
                        <el-option
                          v-for="item in tagListOption"
                          :key="item.id"
                          :label="item.tagName"
                          :value="item.tagCode"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-form>
                </div>
                <!-- 图标库 -->
                <div class="icon-store" v-if="!isFormBox">
                  <!-- <div class="clearfix">
                    <el-button
                      @click="isFormBox = true"
                      class="el-icon-back back-icon fr"
                      size="small"
                    ></el-button>
                  </div> -->
                  <div class="icon-bigbox clearfix">
                    <div
                      class="icon-box fl"
                      v-for="i in iconStoreList"
                      :key="i.id"
                      :class="i.id == checkIconObj.id ? 'checkStyle' : ''"
                      @click="checkIconStore(i)"
                    >
                      <!-- 图片 -->
                      <el-image
                        :key="i.id"
                        class="iconPng"
                        :src="i.iconUrl"
                        fit="cover"
                      >
                      </el-image>
                      <!-- <h1>{{i.iconTitle}}</h1> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <template v-slot:footer>
        <div class="dialog-footer">
          <el-button round @click="cancel" class="cle-btn" size="small"
            >取 消</el-button
          >
          <el-button
            round
            @click="submit"
            type="primary"
            class="sub-btn"
            size="small"
            >确 定</el-button
          >
        </div>
      </template>
    </el-dialog>
    <!-- 删除的对话框 -->
    <popup-del :delVisible="delVisible" @close="closePopupDel"></popup-del>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { postData, getData, postJson } from "@/http/fetch.js";
import { mapState } from "vuex";
import IconUpload from "@/components/upload/IconUpload.vue";
import PopupDel from "@/components/PopupDel.vue";
export default {
  components: {
    IconUpload,
    PopupDel,
    draggable,
  },
  computed: {
    ...mapState(["userInfo", "activeLabelInfo","isAdmin"]),
    schoolInfo() {
      return this.userInfo.teacherInfoList.find(
        (i) => i.classCode == this.$route.query.classCode
      );
    },
  },
  data() {
    return {
      defaultPng: require(`@/assets/image/other/avatar.png`),
      srcPng:
        "https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg",
      addVisible: false,
      hoverShowDel: true,
      form: {
        iconUrl: "",
        evalTitle: "",
        disciplineName: "",
        evalScore: 1,
        evalClassify: "good",
        catalogCode: "", //目录
        tagCodes: "", //标签
      },
      rules: {
        //iconUrl: [{ validator: validateMyselfIconUrl, trigger: "blur" }],
        iconUrl: [
          {
            required: true,
            message: "请选择自定义图标",
            trigger: ["change", "blur"],
          },
        ],
        disciplineName: [
          {
            required: true,
            message: "请选择学科",
            trigger: ["change", "blur"],
          },
        ],
        tagCodes: [
          {
            required: true,
            message: "请选择评价标签",
            trigger: ["blur"],
          },
        ],
        catalogCode: [
          {
            required: true,
            message: "请选择指标目录",
            trigger: ["change", "blur"],
          },
        ],
        evalClassify: [
          {
            required: true,
            message: "请选择类型",
            trigger: ["change", "blur"],
          },
        ],
        evalScore: [
          {
            required: true,
            message: "请输入分值",
            trigger: ["change", "blur"],
          },
        ],
        evalTitle: [
          {
            required: true,
            message: "请输入名称",
            trigger: ["change", "blur"],
          },
          {
            min: 1,
            max: 10,
            message: "长度在 1 到 10 个字符",
            trigger: ["change", "blur"],
          },
        ],
      },

      tableDate: [],
      goodTableDate: [],
      badTableDate: [],
      //系统指标
      serachType: "sys", //系统指标sys 自定义指标myself
      isFormBox: true, //表单 或者 图标库
      sysIconList: [],
      checkSysIconList: [],
      //自定义图标
      iconStoreList: [],
      checkIconObj: { id: "" },
      tagListOption: [],
      //删除 移动当前id
      curIdHover: "",
      curDelId: "",
      delVisible: false,
      //排序
      showSort: false,
    };
  },
  created() {
    this.init();
    //this.getIconStore();
  },
  methods: {
    async init() {
      this.form.disciplineName = this.schoolInfo.disciplineName;

      let selectForm = {
        disciplineCode: this.schoolInfo.disciplineCode, //学科
        grade: this.schoolInfo.grade, //年级
        menuCode: this.activeLabelInfo.menuCode,
        operatorId: this.userInfo.userId,
        pageNum: 1,
        pageSize: 500,
        schoolCode: this.userInfo.schoolCode,
      };
      this.tableDate = await postJson(
        "/eval-school/getEvalDimensionCustomList",
        selectForm
      );
      if (this.tableDate.length > 0) {
        this.goodTableDate = this.tableDate.filter(
          (i) => i.evalClassify == "all" || i.evalClassify == "good"
        );
        this.badTableDate = this.tableDate.filter(
          (i) => i.evalClassify == "all" || i.evalClassify == "bad"
        );
      } else {
        this.goodTableDate = [];
        this.badTableDate = [];
      }
    },
    //得到系统指标 icon
    async getSysIconList() {
      let selectForm = {
        disciplineCode: this.schoolInfo.disciplineCode, //"Chinese", //学科
        grade: this.schoolInfo.grade, //年级
        menuCode: this.activeLabelInfo.menuCode,
        operatorId: this.userInfo.userId,
        pageNum: 1,
        pageSize: -1,
        schoolCode: this.userInfo.schoolCode,
      };
      let { records } = await postJson(
        "/eval-school/getEvalDimensionSchoolListByMobile",
        selectForm
      );
      this.sysIconList = [];
      records.forEach((item) => {
        this.sysIconList.push(item);
      });
    },
    async getTagList() {
      this.tagListOption = await getData("/eval-school/getEvalTagInfoList", {
        schoolCode: this.userInfo.schoolCode,
      });
    },
    add() {
      //this.evalClassify = type;
      this.getSysIconList(); //系统图标
      this.getIconStore(); //标签库
      this.getTagList(); //标签信息

      this.$refs.myselfForm &&
        this.$nextTick(() => {
          this.$refs.myselfForm.resetFields();
          this.$set(this.form, "iconUrl", "");
        });
      this.addVisible = true;
    },
    cancel() {
      this.addVisible = false;
    },
    async getIconStore() {
      let iconForm = {
        iconType: "eval",
        pageNum: 1,
        pageSize: -1,
        schoolCode: this.schoolInfo.schoolCode,
      };
      let { records } = await getData("/eval-school/getIconInfoList", iconForm);
      this.iconStoreList = [];
      records.forEach((i) => {
        this.iconStoreList.push(i);
      });
    },
    goIconPlan() {
      this.isFormBox = false;
    },
    checkIconStore(icon) {
      this.checkIconObj = icon;
      this.isFormBox = true;
      this.$set(this.form, "iconUrl", icon.iconUrl);
    },
    async submit() {
      try {
        //系统图标
        let subForm = {
          disciplineCode: this.schoolInfo.disciplineCode, //"Chinese", //学科
          disciplineName: this.schoolInfo.disciplineName,
          grade: this.schoolInfo.grade,
          gradeName: this.schoolInfo.gradeName,
          menuCode: this.activeLabelInfo.menuCode,
          operatorId: this.userInfo.userId,
          schoolCode: this.userInfo.schoolCode,
        };
        if (this.serachType == "sys") {
          if (this.checkSysIconList.length == 0) {
            this.$message({ type: "warning", message: "请先选择系统指标！" });
            return;
          }
          Object.assign(subForm, { dimensionInfoList: this.checkSysIconList });
        } else {
          await this.$refs.myselfForm.validate();
          Object.assign(subForm, { dimensionInfoList: [this.form] });
        }
        console.log("subForm", subForm);
        await postJson("/eval-school/saveEvalDimensionCustom", subForm);
        this.$message({ type: "success", message: "保存成功" });
        this.init();
        this.addVisible = false;
      } catch (err) {
        console.log("err", err);
      }
    },
    //
    mouseover(id) {
      this.curIdHover = id;
    },
    mouseleave() {
      this.curIdHover = "";
    },
    // 删除 弹框
    showDelPop(id) {
      this.curDelId = id;
      this.delVisible = true;
    },
    // 删除弹框 关闭
    async closePopupDel(status) {
      try {
        !status && (this.delVisible = false);
        if (status) {
          let del = {
            evalCodes: [
              this.tableDate.find((i) => i.id == this.curDelId).evalCode,
            ],
            operatorId: this.userInfo.userId,
          };
          let { resultCode } = await this.$axios.post(
            "/eval-school/removeEvalDimensionCustom",
            del
          );
          if (resultCode === 200) {
            this.init();
            this.$message.success("删除成功");
          } else {
            this.$message.error(msg);
          }
          this.delVisible = false;
        }
      } catch (err) {
        console.log("err", err);
      }
    },
    //移动
    async datadragEnd(evt) {
      evt.preventDefault();
      this.showSort = true;
      // console.log("拖动前的索引 :" + evt.oldIndex);
      // console.log("拖动后的索引 :" + evt.newIndex);
    },
   async saveSort() {
      let evalCodes = this.goodTableDate.map((i) => i.evalCode);
      let badEvalCodes = this.badTableDate.map((i) => i.evalCode);
      badEvalCodes.forEach((i) => evalCodes.push(i));
      let sortForm = {
        operatorId: this.userInfo.userId,
        evalCodes: [...new Set(evalCodes)],
      };
      await postJson("/eval-school/updateEvalDimensionCustomSort", sortForm);
      this.$message({ type: "success", message: "排序保存成功" });
      this.showSort = false;
      this.init()
    },
  },
};
</script>

<style lang="less" scoped>
.praise {
  background-color: #fff;
  padding: 15px;
  .by {
    //border: 1px solid #000;
    margin-bottom: 15px;
    h2 {
      font-size: 15px;
      border-left: 5px solid @color;
      padding: 0 20px 0 10px;
      margin-bottom: 20px;
    }
    .box {
      .del-transition-box {
        // border: 1px solid #000;
        position: relative;
        right: 0px;
        top: 0px;
        .del-transition-but {
          position: absolute;
          right: -18px;
          top: -20px;
          z-index: 2;
        }
      }
      cursor: move;
      width: 120px;
      height: 130px;
      border: 1px solid #eee;
      margin: 0px 20px 20px 0px;
      padding: 9px 2px;
      border-radius: 5px;
      box-sizing: border-box;
      text-align: center;
      .iconPng {
        border: 1px solid #eee;
        width: 75px;
        height: 75px;
        border-radius: 50%;
      }
      .score-rel {
        position: relative;
        left: 0px;
        top: 0px;
        .score {
          box-sizing: content-box;
          position: absolute;
          right: 17px;
          top: 0px;
          z-index: 2;
          // padding: 2px 8px;
          //border: 1px solid #000;
          text-align: center;
          line-height: 25px;
          height: 25px;
          width: 25px;
          border-radius: 50%;
          background-color: @color;
          color: #fff;
        }
        .score-woring {
          background-color: @hong;
        }
      }

      h1 {
        // margin-top: 5px;
        // border: 1px solid #000;
        // font-size: 13px;
        margin-top: 5px;
        //border: 1px solid #000;
        text-align: center;
        width: 100%;
        word-break: break-all;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        font-size: 13px; //加上 要不然 加 复选框 会不显示汉字
      }
    }
    .box:hover {
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }
  }
}
/deep/.add-pop {
  // 新增对话框
  .el-dialog {
    width: 50%;
    min-width: 700px;
    .el-dialog__body {
      padding: 0px;
      .right-box {
        width: 100%;
        .context {
          height: 500px;
          overflow: auto;
          //border: 1px solid rgb(98, 19, 201);
          .sys-box {
            //border: 1px solid #000;
            .icon-box {
              //border: 1px solid yellowgreen;
              margin: 3px 2px;
              width: 100px;
              height: 110px;
              text-align: center;
              .check-select {
                position: relative;
                left: 0px;
                top: 0px;
                z-index: 1;
                .check-box {
                  z-index: 1;
                  position: absolute;
                  right: 0px;
                  top: 0px;
                  z-index: 2;
                  border: 0px solid #000;
                }
              }
              .el-checkbox.is-bordered {
                width: 100px;
                height: 110px;
                //border: 1px solid rgb(226, 17, 17);
                .el-checkbox__input {
                  left: 35px;
                  top: -8px;
                  .el-checkbox__inner {
                    border-radius: 50%;
                    width: 20px;
                    height: 20px;
                  }
                  .el-checkbox__inner::after {
                    border: 3px solid #fff;
                    left: 6px;
                    top: 3px;
                    border-left: 0;
                    border-top: 0;
                  }
                }
              }
              .el-checkbox.is-bordered.el-checkbox--medium .el-checkbox__label {
                opacity: 1;
                width: 1px;
                overflow: hidden;
              }
              .iconPng {
                width: 70px;
                height: 70px;
                margin: 0 auto;
              }
              h1 {
                margin-top: 5px;
                //border: 1px solid #000;
                text-align: center;
                width: 100%;
                word-break: break-all;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                font-size: 13px; //加上 要不然 加 复选框 会不显示汉字
              }
            }
            p {
              width: 100%;
              height: 20px;
              font-size: 13px;
              text-align: center;
            }
          }
          .myself-box {
            // border: 1px solid yellow;
            .form-box {
              width: 350px;
              margin: 0 auto;
              margin-top: 20px;
              .iconPng {
                cursor: pointer;
                // border: 1px solid #000;
                margin-left: 56px;
                margin-bottom: -20px;
                width: 70px;
                height: 70px;
                border-radius: 50%;
              }
              .select-icon-but {
                width: 70px;
                height: 70px;
                margin-left: 56px;
                font-size: 30px;
              }
            }
          }
          .icon-store {
            .back-icon {
              font-size: 20px;
              padding: 5px 13px;
              margin: 0px 20px 10px 0px;
            }
            // border: 1px solid #000;
            .icon-bigbox {
              .icon-box {
                border: 2px solid #eee;
                cursor: pointer;
                margin: 5px;
                width: 75px;
                height: 75px;
                padding: 8px;
                text-align: center;
                border-radius: 4px;
                .iconPng {
                  width: 70px;
                  height: 70px;
                  margin: 0 auto;
                }
              }
              .icon-box:hover {
                border: 2px solid @color;
              }
              .checkStyle {
                border: 2px solid @color;
              }
            }
          }
        }
      }
    }
  }
}
</style>
